var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"),React.createElement("g",{"key":1},React.createElement("rect",{"y":"6","width":"15","height":"3"}))]);
}

Minus.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 15 15","style":{"enableBackground":"new 0 0 15 15"},"xmlSpace":"preserve"};

module.exports = Minus;

Minus.default = Minus;
